export default __webpack_public_path__ + "f1c0551cf552d3df560350d227ccdc12.png";